import React, { useState, useEffect } from "react";
import Header from "../layout/header";
import Arrow from "../images/arrow.png";
import { CiSearch } from "react-icons/ci";
import Delete from "../images/delete.png";
import { AiOutlineDelete } from "react-icons/ai";
import Success from "../images/success.png";
import callingAPI from "../service"
import { useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Clear from "../images/undo.png"
import AccountOpeningLetter from "../images/icons/Account Opening Letter.png"
import CFDInterest from "../images/icons/CFD Interest.png"
import CashDeposit from "../images/icons/Cash Deposit.png"
import CashDividend from "../images/icons/Cash Dividend.png"
import CreditNote from "../images/icons/Credit Note.png"
import CustodyFee from "../images/icons/Custody Fee.png"
import DailyStatements from "../images/icons/Daily Statements.png"
import DebitNote from "../images/icons/Debit Note.png"
import FXConfirmations from "../images/icons/FX Confirmations.png"
import FutureExpiry from "../images/icons/Future Expiry.png"
import GeneralEmails from "../images/icons/General Emails.png"
import MarginNotifications from "../images/icons/Margin Notificaitons-w.png"
import MonthEndStatements from "../images/icons/Month End Statements.png"
import OptionExpiry from "../images/icons/Option Expiry.png"
import ReverseStockSplit from "../images/icons/Reverse Stock Split.png"
import StockDividend from "../images/icons/Stock Dividend.png"
import StockSplit from "../images/icons/Stock Split.png"
import TradeConfirmations from "../images/icons/Trade Confirmations-w.png"
import CashWithdrawal from "../images/icons/cash-withdrawal.png"
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setNotificationData } from "../redux/reducers/notificationSlice";
import { setDashboardData } from "../redux/reducers/dashboardSlice";

export default function Notify({ }) {

    const dispatch = useDispatch();
    const location = useLocation();
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const notificationData = useSelector((state) => state.notification?.notification || []);
    console.log("🛠️ Redux State: Notifications:", notificationData);;
    const categoryData = useSelector((state) => state.notification?.category || []);
    const notificationDiv = useSelector((state) => state.notification?.notificationDiv || false);

    // const { notificationDiv, categoryData } = location.state || {};
    const [show, setShow] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);
    // const [notifications, setNotifications] = useState(notificationData.sort((a, b) => (a.isRead === "No" ? -1 : 1)));
    const [notifications, setNotifications] = useState([]);
    const [allnotifications, setAllNotifications] = useState(notificationData ? notificationData : []);
    const [checkedNotifications, setCheckedNotifications] = useState([]);
    const [startDate, setStartDate] = useState(null);   // State for Start Date
    const [endDate, setEndDate] = useState(null);       // State for End Date
    const [searchKeyword, setSearchKeyword] = useState("");  // State for search input
    const [selectedUserType, setSelectedUserType] = useState(""); // State for user type
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
    const [isMultiDelete, setIsMultiDelete] = useState(false);
    const [selectedNotificationID, setSelectedNotificationID] = useState(null);
    const [isMarkAsUnread, setIsMarkAsUnread] = useState(false);
    const currentDate = new Date();
    const minDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 6, currentDate.getDate());
    const maxDate = new Date();
    const refreshToken = dashboardDetails.refreshToken;
    var userLogId = ""
    const isMonthDisabled = (month, selectedYear) => {
        const minYear = minDate.getFullYear();
        const maxYear = maxDate.getFullYear();
        const minMonth = minDate.getMonth();
        const maxMonth = maxDate.getMonth();

        if (selectedYear === minYear && month < minMonth) return true;
        if (selectedYear === maxYear && month > maxMonth) return true;
        return false;
    };
    const renderCustomHeader = ({ date, changeYear, changeMonth }) => {
        const selectedDate = new Date(date); // Ensure it's a Date object
        return (
            <div>
                {/* Custom header to show selected month and year */}
                <div className="react-datepicker__header">
                    <span>
                        {selectedDate.toLocaleString("default", { month: "long" })} {selectedDate.getFullYear()}
                    </span>
                </div>
                <div>
                    <select
                        value={selectedDate.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(parseInt(value, 10))}
                    >
                        {[...Array(maxDate.getFullYear() - minDate.getFullYear() + 1)].map((_, i) => (
                            <option key={i} value={minDate.getFullYear() + i}>
                                {minDate.getFullYear() + i}
                            </option>
                        ))}
                    </select>
                    <select
                        value={selectedDate.getMonth()}
                        onChange={({ target: { value } }) => changeMonth(parseInt(value, 10))}
                    >
                        {[...Array(12)].map((_, month) => (
                            <option
                                key={month}
                                value={month}
                                disabled={isMonthDisabled(month, selectedDate.getFullYear())}
                            >
                                {new Date(0, month).toLocaleString("default", { month: "long" })}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    };
    const categoryImages = {
        "Account Opening Letter": AccountOpeningLetter,
        "CFD Interest": CFDInterest,
        "Cash Deposit": CashDeposit,
        "Cash Dividend": CashDividend,
        "Credit Note": CreditNote,
        "Custody Fee": CustodyFee,
        "Daily Statements": DailyStatements,
        "Debit Note": DebitNote,
        "FX Confirmations": FXConfirmations,
        "Future Expiry": FutureExpiry,
        "General Emails": GeneralEmails,
        "Margin Notificaitons": MarginNotifications,
        "Month End Statements": MonthEndStatements,
        "Option Expiry": OptionExpiry,
        "Reverse Stock Split": ReverseStockSplit,
        "Stock Dividend": StockDividend,
        "Stock Split": StockSplit,
        "Trade Confirmations": TradeConfirmations,
        "cash-withdrawal": CashWithdrawal,
    };
    const [showMore, setShowMore] = useState(false);
    const [showMoreFlag, setShowMoreFlag] = useState(false);
    const [expandedNotificationId, setExpandedNotificationId] = useState(null);
    const userId = dashboardDetails.userId
    useEffect(() => {
        dispatch(
            setDashboardData({
                moduleId: 3,
                userlogId: ""
            })
        );
        handleUserLog()
        return () => {
            handleUserLog();
        };
    }, []);


    useEffect(() => {
        setNotifications(notificationData ? notificationData : [])
        // setAllNotifications(notificationData?notificationData:[])
    }, [notificationData])


    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 3,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 3,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            // Select all notifications
            const allIds = notifications.map(notification => notification.id);
            setCheckedNotifications(allIds);
        } else {
            // Deselect all
            setCheckedNotifications([]);
        }
    };
    const handleCheckboxChange = (id) => {
        setCheckedNotifications((prev) =>
            prev.includes(id) ? prev.filter((checkedId) => checkedId !== id) : [...prev, id]
        );
    };
    const handleShow = (notification) => {
        setExpandedNotificationId((prevId) =>
            prevId === notification.id ? null : notification.id
        );
        setShowMore(!showMore);
        setSelectedNotification(notification);
        setShow(true);
        if (notification.isRead === "Yes") {
            return null
        }
        else {
            const postData = {
                "notificationId": [notification.id],
                "userId": userId,
                //"refreshToken": refreshToken
            }
            callingAPI(postData, "notifications/readNotification", 'post')
                .then((response) => {
                    console.log("Single Notification read:", response);

                    // dispatch(setNotificationData({
                    //     notification: (prev) =>
                    //         prev.map((n) =>
                    //             n.id === notification.id ? { ...n, isRead: "Yes" } : n
                    //         )
                    // }))
                    dispatch(setNotificationData({
                        notification: notificationData.map((n) =>
                            n.id === notification.id ? { ...n, isRead: "Yes" } : n
                        )
                    }));

                    // setNotifications((prev) =>
                    //     prev.map((n) =>
                    //         n.id === notification.id ? { ...n, isRead: "Yes" } : n
                    //     )
                    // );
                    setShowMoreFlag(!showMore)
                })
                .catch((error) => console.error("Error read notification:", error));
            setCheckedNotifications([]);
        }
    };
    const handleMarkAsRead = () => {
        setIsMarkAsUnread(true); // Open the modal
    };
    const onConfirmMarkAsRead = () => {
        const postData = {
            "notificationId": checkedNotifications,
            "userId": userId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "notifications/readNotification", 'post')
            .then((response) => {
                console.log("multiple Notification Deleted:", response);

                const updatedNotifications = notificationData.map((notification) =>
                    checkedNotifications.includes(notification.id)
                        ? { ...notification, isRead: "Yes" }
                        : notification
                );

                // Dispatch the updated notifications to Redux store
                dispatch(setNotificationData({ notification: updatedNotifications }));

                // setNotifications((prevNotifications) =>
                //     prevNotifications.map((notification) =>
                //         checkedNotifications.includes(notification.id)
                //             ? { ...notification, isRead: "Yes" }
                //             : notification
                //     )
                // );
            })
            .catch((error) => console.error("Error multiple read notification:", error));
        setCheckedNotifications([]);
        setIsMarkAsUnread(false);
    };
    const onCloseMarkAsRead = () => {
        setIsMarkAsUnread(false); // Close the modal without marking as unread
    };
    const handleDelete = (notificationID) => {
        setIsMultiDelete(false);
        setSelectedNotificationID(notificationID);
        setLogoutModalOpen(true);
    }
    const onConfirmDelete = () => {
        if (isMultiDelete) {
            // Multiple notifications delete
            const postData = {
                notificationId: checkedNotifications,
                "userId": userId,
                //"refreshToken": refreshToken
            };
            callingAPI(postData, "notifications/deleteNotification", 'post')
                .then((response) => {
                    console.log("Multiple Notifications Deleted:", response);
                    // setNotifications((prev) => prev.filter((n) => !checkedNotifications.includes(n.id)));
                    const updatedNotifications = notificationData.filter(
                        (n) => !checkedNotifications.includes(n.id)
                    );

                    dispatch(setNotificationData({ notification: updatedNotifications }));

                    setCheckedNotifications([]);
                })
                .catch((error) => console.error("Error deleting notifications:", error));
        } else {
            // Single notification delete
            const postData = {
                notificationId: [selectedNotificationID],
                "userId": userId,
                //"refreshToken": refreshToken
            };
            callingAPI(postData, "notifications/deleteNotification", 'post')
                .then((response) => {
                    console.log("Single Notification Deleted:", response);
                    // setNotifications((prev) => prev.filter((n) => n.id !== selectedNotificationID));

                    // Update Redux state: Remove selected notification
                    const updatedNotifications = notificationData.filter(
                        (n) => n.id !== selectedNotificationID
                    );

                    dispatch(setNotificationData({ notification: updatedNotifications }));
                })
                .catch((error) => console.error("Error deleting notification:", error));
        }
        setLogoutModalOpen(false);
    };
    const onClose = () => {
        setLogoutModalOpen(false);
    };
    const handleDeleteSelected = () => {
        setIsMultiDelete(true);
        setLogoutModalOpen(true);
    };
    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const handleSearchNotification = () => {
        if (new Date(startDate) > new Date(endDate)) {
            alert("To Date must be greater than or equal to From Date");
            return;
        }
        const userId = dashboardDetails.userId
        const postData = {
            userId: userId,
            messageType: selectedUserType,
            fromDate: formatDate(startDate),
            toDate: formatDate(endDate),
            keywords: searchKeyword,
            refreshToken: refreshToken
        };
        callingAPI(postData, "notifications/getNotification", "post")
            .then((response) => {
                console.log("Notifications:", response);
                if (response.data.statusCode === 200) {
                    // setNotifications(response.data.data.notifications)
                    dispatch(setNotificationData({ notification: response.data.data.notifications }));
                }
                else {
                    dispatch(setNotificationData({ notification: [] }));
                }
            })
            .catch((error) => {
                console.error("Error Searching notifications:", error);
                // setNotifications([]);
                dispatch(setNotificationData({ notification: [] }));
            });
    };
    const handleClear = () => {
        console.log("🚀 ~ handleClear ~ allnotifications:", allnotifications)
        setNotifications(allnotifications);
        setSearchKeyword("");
        setStartDate("");
        setEndDate("");
        setSelectedUserType("");
    }
    return (
        <div className="main-wrapper bg-light">
            <div className="top-outer">
                <Header key={showMoreFlag} show={showMoreFlag} />
            </div>
            <div className="container pt-3 pb-5 ">
                <div className="col-12 m-auto col-lg-10 col-md-10">
                    <div className="notification-mainhead col-12 col-lg-12 col-md-12 row">Messages</div>
                    <div className="notify-wraps-main row border-0 px-lg-0 px-md-0">
                        <div className="notification-right col-12 col-lg-4 col-md-12 ps-0">
                            <div className="d-flex align-items-center me-3" >
                                <label class="custom-checkbox" title="Select All">
                                    <input type="checkbox" onChange={handleSelectAll}
                                        checked={checkedNotifications.length === notifications?.length && notifications?.length > 0} />
                                    <span class="checkmark"></span>
                                </label>
                                <label htmlFor="" className="custom-check-label">Select All</label>
                            </div>
                            <div className="notification-status me-3" onClick={checkedNotifications.length > 0 ? handleDeleteSelected : undefined} >Delete</div>
                            <div className="notification-status" onClick={checkedNotifications.length > 0 ? handleMarkAsRead : undefined} >Mark as Read</div>
                        </div>
                        <div className="col-12 col-lg-8 col-md-12 notification-right-sec">
                            <div className="col-lg-3 col-md-3 col-12 margn-top-mob">
                                <select
                                    name="userType"
                                    className="form-control input-sec-bar"
                                    value={selectedUserType}
                                    onChange={(e) => setSelectedUserType(e.target.value)}
                                >
                                    <option value="">Select Message Type</option>
                                    {categoryData.map((category) => (
                                        <option key={category.id} value={category.usertype}>{category.usertype}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-2 col-12 noticatindate  margn-top-mob">
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Start Date"
                                    className="form-control input-sec-bar profile-curved"
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    scrollableYearDropdown
                                    scrollableMonthDropdown
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    renderCustomHeader={renderCustomHeader}
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                            </div>
                            <div className="col-lg-2 col-md-2 col-12 noticatindate  margn-top-mob">
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    placeholderText="End Date"
                                    className="form-control input-sec-bar profile-curved"
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    scrollableYearDropdown
                                    scrollableMonthDropdown
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    renderCustomHeader={renderCustomHeader}
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                            </div>
                            <div className=" col-md-4  margn-top-mob search-barsec">
                                <div className="search">
                                    <input
                                        type="text"
                                        name="search"
                                        className="form-control search-bar"
                                        placeholder="Search Messages"
                                        value={searchKeyword}
                                        autoComplete="off"
                                        onChange={(e) => setSearchKeyword(e.target.value)}
                                    />
                                    <div className="search-icon" onClick={() => handleSearchNotification()}>
                                        <CiSearch fontSize={25} color="#fff" />
                                    </div>
                                </div>
                                <span onClick={() => handleClear()} className="clear-btn"><img src={Clear} alt="" title="Clear" /></span>
                            </div>
                        </div>
                    </div>
                    {console.log(".............................................................................notifications", notifications)}
                    {notifications?.length > 0 ?
                        <div >
                            {notifications.map((notification) => (
                                <div className="not-wraps">
                                    {/* <div className="notify-wraps row active" onClick={handleToggle}> */}
                                    <div className={notification.isRead === "No" ? "notify-wraps row active" : "notify-wraps row"}>
                                        <div className="col-1 col-lg-1 col-md-1 check-div">
                                            <label className="custom-checkbox" title="Select">
                                                <input type="checkbox" checked={checkedNotifications.includes(notification.id)}
                                                    onChange={() => handleCheckboxChange(notification.id)} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-11 col-lg-9 col-md-9 notify-msg">
                                            <div className="notification-icon">
                                                {/* <img src={Arrow} alt="Icon" className="img-fluid" width="20" height="20" /> */}
                                                <img
                                                    src={categoryImages[notification.messageCategory] || Arrow}
                                                    alt="Icon"
                                                    className="img-fluid"
                                                    width="20"
                                                    height="20"
                                                />
                                            </div>
                                            <div onClick={() => handleShow(notification)}>
                                                <div className="notify-bold-text" style={{ cursor: "pointer" }}>{notification.messageCategory}</div>
                                                <div className="notify-text" style={{ cursor: "pointer" }}>
                                                    {expandedNotificationId === notification.id
                                                        ? <span>{notification.message}</span> // Show full message
                                                        : <span>{notification.message.length > 70
                                                            ? notification.message.slice(0, 70) // Show first 60 characters
                                                            : notification.message}</span> // Show full if less than 60 characters
                                                    }
                                                    {notification.message.length > 70 && expandedNotificationId !== notification.id && (
                                                        <span className="show-more-btn">...</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="notify-date col-6 col-lg-2 col-md-2">{notification.createdDate}</div>
                                    </div>
                                    <div className="del-icon" onClick={() => handleDelete(notification.id)}>
                                        <AiOutlineDelete color="#dc3545" title="Delete" />
                                    </div>
                                </div>))}
                        </div>
                        : <div>
                            <div style={{ textAlign: "center", padding: "140px 0" }}>
                                <span >
                                    No Data
                                </span>
                            </div>
                        </div>}
                </div>
            </div>
            {isLogoutModalOpen && (
                <div className="modal-overlay1">
                    <div className="modal-content1">
                        <h3 className='h3LogoutText'>
                            {isMultiDelete ? 'Are you sure you want to delete selected messages?' : 'Are you sure you want to delete this message?'}
                        </h3>
                        <div className="modal-actions1">
                            <button className="btn-confirm1" onClick={onConfirmDelete}>Yes</button>
                            <button className="btn-cancel1" onClick={onClose}>No</button>
                        </div>
                    </div>
                </div>
            )}
            {isMarkAsUnread && (
                <div className="modal-overlay1">
                    <div className="modal-content1">
                        <h3 className='h3LogoutText'>
                            Do you want to mark the selected messages as read?
                        </h3>
                        <div className="modal-actions1">
                            <button className="btn-confirm1" onClick={onConfirmMarkAsRead}>Yes</button>
                            <button className="btn-cancel1" onClick={onCloseMarkAsRead}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}